import React from "react";
import { Link } from "react-router-dom";
import { Auth } from "aws-amplify";
import {
  IoMdBulb,
  IoIosEye,
  IoIosEyeOff,
  IoIosAlert,
  IoIosArrowRoundForward,
  IoIosArrowBack,
} from "react-icons/io";
import { mapAuthError } from "./authErrors";
import SocialButtons from "./SocialButtons";
import "./auth.css";

export default function Login(props) {
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [showPw, setShowPw] = React.useState(false);
  const [error, setError] = React.useState("");
  const [loading, setLoading] = React.useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    // Smart-normalize: lowercase emails (case-insensitive by RFC), pass
    // usernames as-is (Cognito usernames are case-sensitive).
    const raw = email.trim();
    const isEmailish = raw.includes("@");
    const u = isEmailish ? raw.toLowerCase() : raw;
    if (!u || !password) {
      setError("Email atau username dan password wajib diisi.");
      return;
    }
    setLoading(true);
    try {
      await Auth.signIn(u, password);
      props.history.push("/");
    } catch (err) {
      if (err && err.code === "UserNotConfirmedException") {
        props.history.push(
          `/signup/confirm?email=${encodeURIComponent(u)}`
        );
        return;
      }
      // Friendlier hint when a non-email input fails — many legacy
      // pools require the email rather than the historical username.
      let message = mapAuthError(err);
      if (
        !isEmailish &&
        err &&
        (err.code === "NotAuthorizedException" ||
          err.code === "UserNotFoundException")
      ) {
        message =
          message +
          " Untuk akun lama, coba pakai alamat email lengkap (mis. nama@gmail.com).";
      }
      setError(message);
      setLoading(false);
    }
  };

  return (
    <div className="auth">
      <Link to="/landing" className="auth__brand">
        <IoMdBulb size="1.4em" color="var(--brand-700)" />
        cashflow
      </Link>
      <div className="auth__card">
        <h1 className="auth__title">Masuk</h1>
        <p className="auth__subtitle">
          Lanjutkan catat keuanganmu.
        </p>

        {error && (
          <div className="auth__alert" role="alert">
            <IoIosAlert size="1.1em" />
            <span>{error}</span>
          </div>
        )}

        <SocialButtons mode="login" />
        <div className="auth__divider">
          <span>atau dengan email</span>
        </div>

        <form onSubmit={submit} noValidate>
          <div className="auth__field">
            <label className="auth__field-label" htmlFor="auth-email">
              Email atau Username
            </label>
            <input
              id="auth-email"
              type="text"
              className="auth__input"
              autoComplete="username"
              autoFocus
              value={email}
              disabled={loading}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="kamu@email.com"
            />
          </div>

          <div className="auth__field">
            <label className="auth__field-label" htmlFor="auth-password">
              Password
            </label>
            <div className="auth__password-wrap">
              <input
                id="auth-password"
                type={showPw ? "text" : "password"}
                className="auth__input"
                autoComplete="current-password"
                value={password}
                disabled={loading}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
              />
              <button
                type="button"
                className="auth__password-toggle"
                onClick={() => setShowPw((s) => !s)}
                aria-label={showPw ? "Sembunyikan password" : "Lihat password"}
                tabIndex={-1}
              >
                {showPw ? <IoIosEyeOff /> : <IoIosEye />}
              </button>
            </div>
          </div>

          <div className="auth__hint-row">
            <span />
            <Link to="/forgot" className="auth__hint-link">
              Lupa password?
            </Link>
          </div>

          <button type="submit" className="auth__submit" disabled={loading}>
            {loading ? (
              <span className="auth__spinner" />
            ) : (
              <>
                Masuk
                <IoIosArrowRoundForward size="1.3em" />
              </>
            )}
          </button>
        </form>

        <div className="auth__footer">
          Belum punya akun?
          <Link to="/signup">Daftar</Link>
        </div>
      </div>

      <Link to="/landing" className="auth__back">
        <IoIosArrowBack /> Kembali ke beranda
      </Link>
    </div>
  );
}
